import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface EnablementProfessional {
  id: number;
  name: string;
  is_enabled: boolean;
}

export interface ServiceProfessionalsData {
  service_id: number;
  restrict_mode: boolean;
  professionals: EnablementProfessional[];
}

export interface EnablementServiceItem {
  id: number;
  name: string;
  unit_id: number;
  is_enabled: boolean;
}

export interface ProfessionalServicesData {
  professional_id: number;
  restrict_mode: boolean;
  services: EnablementServiceItem[];
}

export const getServiceProfessionals = (
  serviceId: number
): Promise<ApiResponse<ServiceProfessionalsData>> =>
  api.get<ApiResponse<ServiceProfessionalsData>>(`/services/${serviceId}/professionals`);

export const syncServiceProfessionals = (
  serviceId: number,
  professionalIds: number[]
): Promise<ApiResponse<ServiceProfessionalsData & { no_op?: boolean }>> =>
  api.put<ApiResponse<ServiceProfessionalsData & { no_op?: boolean }>>(
    `/services/${serviceId}/professionals`,
    { professional_ids: professionalIds }
  );

export const getProfessionalServices = (
  professionalId: number
): Promise<ApiResponse<ProfessionalServicesData>> =>
  api.get<ApiResponse<ProfessionalServicesData>>(
    `/professionals/${professionalId}/services`
  );

export const syncProfessionalServices = (
  professionalId: number,
  serviceIds: number[]
): Promise<ApiResponse<ProfessionalServicesData & { no_op?: boolean }>> =>
  api.put<ApiResponse<ProfessionalServicesData & { no_op?: boolean }>>(
    `/professionals/${professionalId}/services`,
    { service_ids: serviceIds }
  );

export const countEnabledProfessionals = (data: ServiceProfessionalsData): number =>
  data.professionals.filter((professional) => professional.is_enabled).length;
